import React from 'react';
import { useTranslation } from 'react-i18next';
import { Job, JobStatusEnum } from 'graphql-common';
import Chip, { ChipTypes } from '@lib/components/Chip/Chip';

type Props = {
  data: Job;
};

export default function JobStatusChip(props: Props) {
  const { data } = props;
  const { status } = data;
  const { t } = useTranslation();

  let chipLabel = t('queued');
  let chipType = ChipTypes.chipViolet;
  if (status === JobStatusEnum.Complete) {
    chipLabel = t('completed');
    chipType = ChipTypes.chipGreen;
  } else if (status === JobStatusEnum.Failed) {
    chipLabel = t('failed');
    chipType = ChipTypes.chipRed;
  } else if (status === JobStatusEnum.Working) {
    chipLabel = t('in-progress');
    chipType = ChipTypes.chipBlue;
  } else if (status === JobStatusEnum.Retrying) {
    chipLabel = t('retrying');
    chipType = ChipTypes.chipYellow;
  } else if (status === JobStatusEnum.Interrupted) {
    chipLabel = t('interrupted');
    chipType = ChipTypes.chipCorral;
  } else if (status === JobStatusEnum.Stopped) {
    chipLabel = t('stopped');
    chipType = ChipTypes.chipBlack;
  }

  return <Chip type={chipType} label={chipLabel} />;
}
